import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="impressum-page">
      <section className="section-padding bg-surface">
        <div className="container-max">
          <h1 className="text-4xl md:text-5xl font-heading font-bold uppercase tracking-tighter mb-4">
            <span className="text-primary">Impressum</span>
          </h1>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="max-w-3xl space-y-8">
            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Angaben gemäß § 5 ECG / § 25 MedienG</h2>
              <p className="text-text-secondary">
                House of Darts<br />
                ZVR-Zahl: 1916614880
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Sitz des Vereins</h2>
              <p className="text-text-secondary">
                Straßwalchen (Straßwalchen)
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Zustellanschrift</h2>
              <div className="flex items-start gap-3 text-text-secondary">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <p>
                  5204 Straßwalchen<br />
                  Marktplatz 11<br />
                  Österreich
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Vertretungsberechtigter (Obmann)</h2>
              <p className="text-text-secondary">Subhan Klicic</p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Kontakt</h2>
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-text-secondary">
                  <Mail className="w-5 h-5 text-accent flex-shrink-0" />
                  <a href="mailto:house.of.darts.strasswalchen@gmail.com" className="hover:text-accent transition-colors">
                    house.of.darts.strasswalchen@gmail.com
                  </a>
                </div>
                <div className="flex items-center gap-3 text-text-secondary">
                  <Phone className="w-5 h-5 text-accent flex-shrink-0" />
                  <a href="tel:+4367763139171" className="hover:text-accent transition-colors">
                    0677 63139171
                  </a>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Vereinszweck</h2>
              <p className="text-text-secondary">
                Dartverein zur Förderung des Dartsports sowie Organisation von Trainings, Turnieren und Vereinsaktivitäten.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Aufsichtsbehörde</h2>
              <p className="text-text-secondary">
                Bezirkshauptmannschaft Salzburg-Umgebung
              </p>
            </div>

            <div className="border-t border-white/10 pt-8">
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Haftung für Inhalte</h2>
              <p className="text-text-secondary text-sm">
                Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte wird keine Gewähr übernommen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 ECG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Eine Verpflichtung zur Überwachung übermittelter oder gespeicherter fremder Informationen besteht jedoch nicht.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Haftung für Links</h2>
              <p className="text-text-secondary text-sm">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">Urheberrecht</h2>
              <p className="text-text-secondary text-sm">
                Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;
